import React, { Component } from 'react'
import { Button, FormGroup, FormControl } from "react-bootstrap"
import logologin from '../../Comman/images/logo-new.png'

import logobackground from '../../Comman/images/loginbg.png'
import { Redirect, withRouter } from 'react-router-dom'
import SimpleReactValidator from 'simple-react-validator';
import {Link} from 'react-router-dom';
import RedirectRegistrationComponent from '../../Comman/components/redirectRegistrationComponent'

const inputStyle = {
  margin: '15px',
 // border: '5px solid pink'
};

class heartRunnerRegistrationComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      heartRunnerUser:{
        FirstName:'',
        LastName:'',
        PhoneNumber:'',
        EmailId:'',
        Username:'',
        Password:'',
        confirmPassword:'',
        CertificateID:'',
        resourceName :'',
       organizationName: ''
      },
      heartRunnerRadio: true
    };
    this.baseState=this.state;
  }
  
  componentWillMount() { 
    this.validator = new SimpleReactValidator(); 
  }
   
  componentWillReceiveProps(nextProps) { 
   if (nextProps.RegisterInfo !== this.props.RegisterInfo) {
  if(nextProps.RegisterInfo.heartRunnerOrgInfo.length >0){
    this.setState({organizationName: nextProps.RegisterInfo.heartRunnerOrgInfo[0].OrganizationName} )   
  }
      if (nextProps.RegisterInfo.statusCode == 200) {
                //this.setRedirect();
                this.validator.hideMessages();

                this.setState(this.baseState);
        }
       
      }

  }
 
  handleChange = event => {
   
    let value = event.target.value;
    let name = event.target.name;
    if(event.target.id=='LastName' && this.state.heartRunnerUser.FirstName!=undefined && this.state.heartRunnerUser.LastName!=undefined){
      let fName=this.state.heartRunnerUser.FirstName
      let lName=this.state.heartRunnerUser.LastName

      if(fName.length >=2 && lName.length>=2){
        let Username=fName.substring(0, 2)+lName.substring(0, 2)+Math.floor(Math.random() * 90 + 10);

        this.setState( prevState => ({ heartRunnerUser : 
          {...prevState.heartRunnerUser, Username: Username}
        }))            
      }
    }
    this.setState( prevState => ({ heartRunnerUser : 
      {...prevState.heartRunnerUser, [name]: value}
    }))
  }
 
 

  submitOrganization = event => {
    event.preventDefault();
    if (this.validator.allValid()) {
        let heartRunnerState=this.state.heartRunnerUser;        
        heartRunnerState.OrganizationID=this.props.RegisterInfo.heartRunnerOrgInfo[0].OrganizationID;

        this.props.registerHeartRunner(heartRunnerState);
        
      
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  heartRunnerLogin=()=>{
    this.props.history.push('/heartrunnerlogin')
  }

  render() {  
    return (
      <div className="loginbg loginbg-ragistration">
    <div className="login-main">
        <div className="login-logo">
            <img src={logologin} />
        </div>
       
       
          {this.props.RegisterInfo.statusCode==201 || this.props.RegisterInfo.statusCode==500?
            <div class="alert alert-danger">
                {this.props.RegisterInfo.Message}
              </div>
            :''
            
          }
          {this.props.RegisterInfo.statusCode==200?
            <div class="alert alert-success">
                {this.props.RegisterInfo.Message}
                <span className="pl-md-2">
                  <Link to="/heartrunnerlogin">Login</Link>
                </span>
              </div>
            :''
            
          }
         
        <form onSubmit={this.submitOrganization}>
            <div className="row">
                <div className="col-sm-6">
                    <FormGroup controlId="FirstName">
                        <div className="login-fm">
                            <FormControl 
                              className="login-main-form-control" 
                              type="text" 
                              autoFocus 
                              name="FirstName"
                              value={this.state.heartRunnerUser.FirstName} 
                              onChange={this.handleChange} 
                              placeholder="Enter First Name" 
                            />
                        </div>
                        {this.validator.message('FirstName', this.state.heartRunnerUser.FirstName, 'required|alpha_num_space|min:3')}
                    </FormGroup>

                </div>
                <div className="col-sm-6">
                    <FormGroup controlId="LastName">
                        <div className="login-fm">
                            <FormControl 
                              className="login-main-form-control" 
                              value={this.state.heartRunnerUser.LastName} 
                              onChange={this.handleChange} 
                              type="text" 
                              name="LastName"
                              autoFocus 
                              placeholder="Enter Last Name" 
                            />
                        </div>
                        {this.validator.message('LastName', this.state.heartRunnerUser.LastName, 'required|alpha_num_space|min:3')}
                        
                    </FormGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6">
                    <FormGroup controlId="PhoneNumber">
                        <div className="login-fm">
                            <FormControl 
                              className="login-main-form-control" 
                              value={this.state.heartRunnerUser.PhoneNumber} 
                              onChange={this.handleChange} 
                              type="text" 
                              name="PhoneNumber"
                              autoFocus 
                              placeholder="Enter Phone Number" 
                            />
                        </div>
                         {this.validator.message('PhoneNumber', this.state.heartRunnerUser.PhoneNumber, 'required|phone|min:8|max:16')}

                    </FormGroup>
                </div>
                <div className="col-sm-6">
                  <FormGroup controlId="EmailId">
                        <div className="login-fm">
                            <FormControl 
                              className="login-main-form-control" 
                              value={this.state.heartRunnerUser.EmailId} 
                              onChange={this.handleChange} 
                              type="text" 
                              autoFocus
                              name="EmailId" 
                              placeholder="Enter EmailId" 
                            />
                        </div>
                          {this.validator.message('EmailId', this.state.heartRunnerUser.EmailId, 'required|email')}

                    </FormGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6">
                    <FormGroup controlId="Username">
                        <div className="login-fm">
                            <FormControl 
                            className="login-main-form-control" 
                            value={this.state.heartRunnerUser.Username} 
                            onChange={this.handleChange} 
                            type="text" 
                            autoFocus 
                            name="Username"
                            placeholder="Enter Username"  />
                        </div>
                      {this.validator.message('Username', this.state.heartRunnerUser.Username, 'required|min:5')}
                      

                    </FormGroup>
                </div>
                <div className="col-sm-6"> 
                 <FormGroup controlId="organization">
                        <div className="login-fm">
                            <FormControl 
                              autoFocus 
                              value={this.state.organizationName}   // this.props.RegisterInfo.heartRunnerOrgInfo.OrganizationName
                              className="login-main-form-control" 
                              placeholder="Organization" 
                              ref="OrganizationID"
                              disabled
                            /> 
                        </div>
                       
                    </FormGroup>
                </div>
                
            </div>
            <div className="row">
                <div className="col-sm-6">
                    <FormGroup controlId="CertificateID">
                        <div className="login-fm">
                            <FormControl 
                            className="login-main-form-control" 
                            value={this.state.heartRunnerUser.CertificateID} 
                            onChange={this.handleChange} 
                            type="text" 
                            autoFocus 
                            name="CertificateID"
                            placeholder="Enter Certificate ID"  />
                        </div>
                      {this.validator.message('CertificateID', this.state.heartRunnerUser.CertificateID, 'required|min:5')}
                      

                    </FormGroup>
                </div>
                <div className="col-sm-6">
                    <FormGroup controlId="resourceName">
                        <div className="login-fm">
                            <FormControl 
                            className="login-main-form-control" 
                            value={this.state.heartRunnerUser.resourceName} 
                            onChange={this.handleChange} 
                            type="text" 
                            name="resourceName"
                            placeholder="Enter Resource Name"  
                            />
                        </div> 
                    </FormGroup>
                </div>
                
            </div>
            
                       
            <div className="row">
                <div className="col-sm-6">
                    <FormGroup controlId="Password">
                        <div className="login-fm">
                            <FormControl 
                              className="login-main-form-control" 
                              value={this.state.heartRunnerUser.Password} 
                              onChange={this.handleChange} 
                              type="Password" 
                              autoFocus 
                              name="Password"
                              placeholder="Enter Password" 
                            />
                        </div>
                      {this.validator.message('Password', this.state.heartRunnerUser.Password, 'required|min:6')}
                        
                    </FormGroup>
                </div>
                <div className="col-sm-6">
                    <FormGroup controlId="confirmPassword">
                        <div className="login-fm">
                            <FormControl 
                            className="login-main-form-control" 
                            value={this.state.heartRunnerUser.confirmPassword} 
                            onChange={this.handleChange} 
                            type="Password" 
                            name="confirmPassword"
                            placeholder="Enter Confirm Password" 
                            //onBlur={()=> this.validator.showMessageFor('confirmPassword')} 
                            />
                        </div>
                        {this.validator.message('confirmPassword', 
                        this.state.heartRunnerUser.confirmPassword, 
                        `required|in:${this.state.heartRunnerUser.Password}`, 
                        {messages: {in: 'Passwords need to match!'}})
                        }
                    </FormGroup>
                </div>
            </div>
            <div className="row">
                <div className="login-button">
                    
                    <Button type="text"> REGISTER </Button>
                    <p>
                        
                        <a href="#">
                          <span className="yellow">
                          <button className="signUp" onClick={this.heartRunnerLogin}>Login</button>
                          </span>
                        </a>
                    </p>
                </div>
            </div>

        </form>
    </div>
</div>);
  }
}


export default withRouter(heartRunnerRegistrationComponent)
